import { api } from "@/lib/api";

// Ask the backend for a one-time challenge, sign it with the wallet, and return the
// exact bytes + signature to submit. `signPersonalMessage` is the dapp-kit mutateAsync fn.
export async function getWalletProof(signPersonalMessage, address, purpose, ref) {
  const { data } = await api.post("/wallet/challenge", { address, purpose, ref });
  const messageBytes = Uint8Array.from(atob(data.message), (c) => c.charCodeAt(0));
  const res = await signPersonalMessage({ message: messageBytes });
  // Submit the wallet-returned bytes (must match the server challenge) + signature.
  return { message: res.bytes, signature: res.signature };
}
